export default __webpack_public_path__ + "static/media/Group17.b04d26e1.png";